import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { formatAmountCurrency } from '../../utils';
import { getBilletteriePrice, hasBilletteriePublicPrice } from '../../services/billetterie/utils';

// Prix public barré (s'il est plus élevé) puis remisé ; libellés sr-only car <del> n'est pas restitué
const BilletteriePriceComponent = ({
    partner,
    valueTag: ValueTag,
    PUBLIC_PRICE,
    DISCOUNTED_PRICE
}) => {
    const withPublicPrice = hasBilletteriePublicPrice(partner);

    return (
        <React.Fragment>
            {withPublicPrice && (
                <React.Fragment>
                    <del>
                        <span className="sr-only">{PUBLIC_PRICE} </span>
                        {formatAmountCurrency(partner.minPricePublic)}
                    </del>
                    &nbsp;
                </React.Fragment>
            )}
            <ValueTag>
                {withPublicPrice && <span className="sr-only">{DISCOUNTED_PRICE} </span>}
                {formatAmountCurrency(getBilletteriePrice(partner))}
            </ValueTag>
        </React.Fragment>
    );
};

BilletteriePriceComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    valueTag: PropTypes.string
};

BilletteriePriceComponent.defaultProps = {
    valueTag: 'strong'
};

const mapStateToProps = state => ({
    PUBLIC_PRICE: state.i18n.feature.partenaire.PUBLIC_PRICE,
    DISCOUNTED_PRICE: state.i18n.feature.partenaire.DISCOUNTED_PRICE
});

export default connect(mapStateToProps)(BilletteriePriceComponent);



// WEBPACK FOOTER //
// ./src/components/partner/BilletteriePriceComponent.js